import http from '../core/http-common'
import { ICalendarPlan, ICalendarStatistic } from '../types/CalendarType'
import { ITransactionResponse } from '../types/MainType'

class CalendarService {
  getCalendarStatistics(startDate: string, endDate: string) {
    return http.get<ICalendarStatistic>(`/Reservation/GetStatistics?startDate=${startDate}&endDate=${endDate}`)
  }

  getManagerCalendarStatistics(startDate: string, endDate: string) {
    return http.get<ICalendarStatistic>(`/ReservationManager/GetStatistics?startDate=${startDate}&endDate=${endDate}`)
  }

  getMyPlans(startDate: string, endDate: string) {
    return http.get<ICalendarPlan[]>(`/Plan/GetMyPlanList?startDate=${startDate}&endDate=${endDate}`)
  }

  getPlanList(employeeId: number, startDate: string, endDate: string) {
    return http.get<ICalendarPlan[]>(
      `/Plan/GetPlanList?employeeId=${employeeId}&startDate=${startDate}&endDate=${endDate}`
    )
  }
  saveMultipleReservation(request: any) {
    return http.post<ITransactionResponse>('/CompositeReservation/SaveReservation', request)
  }
  deleteMultipleReservation(request: any) {
    return http.post<ITransactionResponse>('/CompositeReservation/DeleteReservation', request)
  }
  deleteMultipleDoctorReservation(request: any) {
    return http.post<ITransactionResponse>('/DoctorReservation/DeleteMultipleDoctorReservation', request)
  }
  deleteMultipleCoiffeurReservation(request: any) {
    return http.post<ITransactionResponse>('/CoiffeurReservation/DeleteMultipleCoiffeurReservation', request)
  }
  deleteMultipleGymSalonRes(request: any) {
    return http.post<ITransactionResponse>('/GymSaloonReservation/DeleteMultipleReservation', request)
  }
  deleteMultipleGymGroupRes(request: any) {
    return http.post<ITransactionResponse>('/GymGroupLessonsReservation/DeleteMultipleReservation', request)
  }
  deleteMultipleGymTrainerRes(request: any) {
    return http.post<ITransactionResponse>('/GymTrainerReservation/DeleteMultipleReservation', request)
  }
  deleteMultipleLactationRes(request: any) {
    return http.post<ITransactionResponse>('/LactationReservation/DeleteMultipleReservation', request)
  }
  deleteMultipleMeetingRes(request: any) {
    return http.post<ITransactionResponse>('/MeetingRoomReservation/DeleteMultipleReservation', request)
  }
  deleteMultiplePoolVehicleRes(request: any) {
    return http.post<ITransactionResponse>('/PoolVehicleReservation/DeleteMultipleReservation', request)
  }
}

export default new CalendarService()
